import {User} from '@hconnect/apiclient'
import {Button} from '@hm/fundamental'
import {mdiLockOutline} from '@mdi/js'
import React from 'react'

import {IconTextButton} from '../../components/IconTextButton'
import {useLoggedInUserProfile} from '../../hooks/useLoggedInUser'
import {useTranslation} from '../../hooks/useTranslation'

import {CloneIcon} from './CloneIcon'

const ALLOWED_ROLES = new Set(['GLOBAL_ADMIN', 'SUPER_ADMIN', 'SUPPORT_AGENT'])

type CloneUserButtonProps = {
  isLoading: boolean
  onClick: () => void
  loggedInUserProfile?: User | null
  newUserProfile?: boolean
}

export const CloneUserButton = ({
  isLoading,
  onClick,
  loggedInUserProfile,
  newUserProfile
}: CloneUserButtonProps) => {
  const {t} = useTranslation()
  const loggedInUserProfileData = useLoggedInUserProfile(loggedInUserProfile)

  const loggedInUserIsAllowedToClone = loggedInUserProfileData?.hasRoles.some((role: string) =>
    ALLOWED_ROLES.has(role)
  )

  if (!loggedInUserIsAllowedToClone) {
    return null
  }

  return (
    <>
      {newUserProfile ? (
        <Button icon={mdiLockOutline} data-test-id="button-clone-user" onClick={() => onClick()}>
          {t('manageUser.cloneUser')}
        </Button>
      ) : (
        <IconTextButton
          loading={isLoading}
          label={t('manageUser.cloneUser')}
          IconComponent={CloneIcon}
          onClick={() => onClick()}
          data-test-id="button-clone-user"
        />
      )}
    </>
  )
}
